import {
  ApplicationConfig,
  ErrorHandler,
  importProvidersFrom,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { routes } from './app.routes';
import { BrowserModule } from '@angular/platform-browser';
import {
  provideHttpClient,
  withInterceptorsFromDi,
  HTTP_INTERCEPTORS,
  withFetch,
  withInterceptors,
} from '@angular/common/http';
import { provideNoopAnimations } from '@angular/platform-browser/animations';
import { providePrimeNG } from 'primeng/config';
import Lara from '@primeuix/themes/lara';

import { DatePipe } from '@angular/common';
import { errorInterceptor } from './interceptors/error.interceptor';
import { SharedDataService } from './shared/services/shared-data-service';
import { loaderInterceptor } from './interceptors/loader.interceptor';
import { GlobalErrorHandlerService } from './shared/services/global-error-handler.service';
import { NzModalService } from 'ng-zorro-antd/modal';
import { authInterceptor } from './interceptors/auth.interceptor';
import { environment } from '../environments/environment';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withInMemoryScrolling({scrollPositionRestoration: 'top'})),
    importProvidersFrom(
      BrowserModule,
    ),
    provideNoopAnimations(),
    provideHttpClient(withInterceptorsFromDi(), withFetch(), withInterceptors([authInterceptor,errorInterceptor, loaderInterceptor])),
    providePrimeNG({
      theme: {
        preset: Lara,
        options: {
          darkModeSelector: false
        }
      },
       overlayAppendTo: 'body',
      // Raise overlay layers above fixed headers/footers and app chrome.
      zIndex: {
        modal: 7000,
        overlay: 6000,
        menu: 6000,
        tooltip: 7000,
      }
    }),
    { provide: ErrorHandler, useClass: GlobalErrorHandlerService },
    DatePipe,
    SharedDataService,
    NzModalService,
  ],
};
